import React from 'react';
import * as Icons from '@/components/Icons';
import { Toaster } from '@/components/ui/sonner';
import { toast } from 'sonner';

const IconGallery: React.FC = () => {
  const copyToClipboard = (iconName: string) => {
    const componentText = `<${iconName} />`;
    navigator.clipboard.writeText(componentText).then(() => {
      toast(`Component ${iconName} copied to clipboard`);
    });
  };

  const iconComponents = Object.entries(Icons).filter(([name]) =>
    name.endsWith('Icon'),
  );

  return (
    <div className="bg-gray-100 min-h-screen p-8">
      <h1 className="text-4xl font-bold mb-8 text-center text-gray-800">
        Icon Gallery
      </h1>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 gap-6">
        {iconComponents.map(([name, IconComponent]) => (
          <div
            key={name}
            className="bg-white rounded-lg shadow-md p-4 flex flex-col items-center justify-between hover:shadow-lg transition-shadow duration-300"
          >
            <div className="w-16 h-16 flex items-center justify-center mb-4">
              <IconComponent className="w-10 h-10 text-blue-500" />
            </div>
            <p
              className="text-sm text-center text-gray-600 cursor-pointer hover:text-blue-500 transition-colors duration-300"
              onClick={() => copyToClipboard(name)}
            >
              {name}
            </p>
          </div>
        ))}
      </div>
      <Toaster />
    </div>
  );
};

export default IconGallery;
